<template>
<slider class="gallery">
  <slide v-for="(item, n) in gallery" :key="n" class="slide" :video="item.video" :image="item.image" :link="item.link" :caption="item.caption" :num="n"></slide>
</slider>
</template>

<script>
import Vue from 'vue'
export default Vue.component('ArtistGallery', {
  props: ['gallery', 'position', 'playVideo'],
  watch: {
    playVideo(to, from) {
      if(to && !from) {
        this.playFirstVideo()
      }
    }
  },
  methods: {
    playFirstVideo() {
      const video = this.$el.querySelector('.slide.is-selected video')
      if(video) {
        video.autoplay = true
        video.play()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/_variables.scss';

/deep/ .flickity-viewport {
  height: 75vh;
  overflow: visible;

  @media (max-width: $break-small) {
    height: $mobile-gallery-height;
  }
}

.gallery {
  margin-right: #{0 - $gutter};
  margin-left: #{0 - $gutter};
  padding-left: $gutter;
  padding-right: $gutter;
  padding-bottom: $gutter;
  padding-top: $gutter;
  user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/components/artist-gallery.vue